import React from "react"
import autobind from "class-autobind"
import numeral from "numeral"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IProps {
    totalSavings: number
}

interface IState {
}

const subTitleClass = {
    textTransform: "uppercase",
    fontSize: "14pt",
    textAlign: "center",
    weight: "bold",
    marginBottom: 10,
}

const titleClass = {
    fontSize: "45pt",
    lineHeight: "1em",
    textAlign: "center",
    minWidth: "350px",
}


const totalStyles = {
    color: "#3AAD07",
}


export default class TotalWaveData extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)

        this.state = {
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{position: "relative", top: -50}}>
                <div style={{...subTitleClass, ...totalStyles}}>
                    TOTAL YEARLY SAVINGS
                </div>
                <div style={{...titleClass, ...totalStyles}}>
                    {numeral(this.props.totalSavings).format('$0.0a')}
                </div>                                        
            </div>
        )
    }
}